import { store } from '../../../index';
import { addHeartbeatId, removeHeartbeatId } from '../../internal/actionCreators';
import axios from 'axios';

import { createChillipharmUrl } from '../../../utils/aws/aws';

export const startHeartbeat = (fileIndex) => {
  sendHeartbeat(fileIndex, 'start');
  const heartBeatId = setInterval(function () {
    processHeartbeat(fileIndex);
  }, 15000);
  store.dispatch(addHeartbeatId(fileIndex, heartBeatId));
};

export const processHeartbeat = (fileIndex) => {
  const uploadStatus = store.getState().files.files[fileIndex].status;

  if (window.restartSessionTimeOut) {
    window.restartSessionTimeOut();
  }

  if (uploadStatus === 'Uploaded' || uploadStatus === 'Error') {
    store.getState().internal.heartbeatIds.map((heartIds) => {
      if (heartIds.fileIndex === fileIndex) {
        clearInterval(heartIds.heartbeatId);
        store.dispatch(removeHeartbeatId(heartIds.fileIndex));
        sendHeartbeat(fileIndex, 'stop');
      }
    });
  } else {
    sendHeartbeat(fileIndex, 'continue');
  }
};

// Post to Heartbeat backend endpoint
export function sendHeartbeat(fileIndex, status) {
  const file = getFile(store.getState(), fileIndex);
  const { totalPartNumbers, totalUploadedBytes } = store.getState().files.files[fileIndex].uploadInfo;
  let uploadStatus;

  switch (status) {
    case 'start':
      uploadStatus = 'starting';
      break;
    case 'continue':
      uploadStatus = 'uploading';
      break;
    case 'stop':
      uploadStatus = file.status === 'Uploaded' ? 'completed' : file.status === 'Error' ? 'failed' : file.status;
      break;
    default:
      uploadStatus = '';
  }

  axios.post(
    createChillipharmUrl('heartbeat'),
    {
      authenticity_token: store.getState().internal.authenticityToken,
      status: uploadStatus,
      s3_file: file.originalFileData.name,
      progress: file.uploadProgress,
      sent_bytes:
        file.uploadProgress === 0 ? 0 : totalPartNumbers > 1 ? totalUploadedBytes : file.originalFileData.size,
      total_bytes: file.originalFileData.size,
      upload_type: 'standard',
    },
    {
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
      },
    },
  );
}

export function getFile(state, index) {
  return state.files.files.find((f, i) => {
    return i === index;
  });
}
